import { render, staticRenderFns } from "./AddOrEditCompanyForm.vue?vue&type=template&id=135c3ef4"
import script from "./AddOrEditCompanyForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditCompanyForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditCompanyForm.vue?vue&type=style&index=0&id=135c3ef4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports